import { AxiosResponse } from 'axios';
import { DeleteResponse, RepositoryResponseCode, RepositorySaveResponse, SaveConflictResponse, SaveForbiddenResponse } from './repository-interface';

export type SaveResponseResult =
    | RepositorySaveResponse
    | SaveConflictResponse<unknown>
    | SaveForbiddenResponse<unknown>;

export interface RepositoryResponseHandler {
    mapSaveResponse(response: AxiosResponse, code: RepositoryResponseCode): SaveResponseResult;
    mapDeleteResponse(response: AxiosResponse, code: RepositoryResponseCode, isSuccess: boolean): DeleteResponse;
}

export class RepositoryResponseHandler implements RepositoryResponseHandler {
    public mapSaveResponse(response: AxiosResponse, code: RepositoryResponseCode): SaveResponseResult {
        switch (code) {
            case RepositoryResponseCode.Success:
                return { code, object: response.data.object };
            case RepositoryResponseCode.Forbidden:
                return { code, kind: response.data.code };
            case RepositoryResponseCode.Conflict:
                return { code, conflicts: Array.isArray(response.data) ? response.data : [response.data].filter(Boolean) };
            case RepositoryResponseCode.OutOfDateData:
            case RepositoryResponseCode.ValidationError:
            case RepositoryResponseCode.DataNotFound:
            case RepositoryResponseCode.ExternalError:
            default:
                return { code };
        }
    }

    public mapDeleteResponse(response: AxiosResponse, code: RepositoryResponseCode, isSuccess: boolean): DeleteResponse {
        if (isSuccess) {
            return {
                deletedSuccessfully: response.status >= 200 && response.status < 300,
                errorCode: response.data?.code
            };
        }

        return {
            responseCode: code,
            deletedSuccessfully: response.status >= 200 && response.status < 300,
            errorCode: response.data?.code,
            target: response.data?.target
        };
    }
}

export const repositoryResponseHandler: RepositoryResponseHandler = new RepositoryResponseHandler();
